var React = require('react');

function ResponsiveDesign (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"48","height":"48","rx":"8","fill":"white","key":0}),React.createElement("mask",{"id":"mask0_5117_270","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"12","y":"12","width":"24","height":"24","key":1},React.createElement("rect",{"x":"12","y":"12","width":"24","height":"24","fill":"#D9D9D9"})),React.createElement("g",{"mask":"url(#mask0_5117_270)","key":2},React.createElement("path",{"d":"M15 33V20H20V15H33V33H15ZM28 31H31V17H22V20H28V31ZM22 31H26V22H22V31ZM17 31H20V22H17V31Z","fill":"#064861"}))]);
}

ResponsiveDesign.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = ResponsiveDesign;

ResponsiveDesign.default = ResponsiveDesign;
